import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

function api() {
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
}

export function adminApi() {
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
}

export async function getReferences(type, schoolId) {
    const res = await api().get(`/references/${type}`, { params: schoolId ? { schoolId } : {} });
    return res.data;
}

export async function listAdminReferences(type) {
    const res = await adminApi().get('/admin/references', { params: type ? { type } : {} });
    return res.data;
}

export async function createAdminReference(body) {
    return adminApi().post('/admin/references', body);
}

export async function updateAdminReference(id, body) {
    return adminApi().put(`/admin/references/${id}`, body);
}

export async function deleteAdminReference(id) {
    return adminApi().delete(`/admin/references/${id}`);
}

export async function listWebhooks(schoolId) {
    return api().get('/integration/webhooks', { params: { schoolId } });
}

export async function saveWebhook(body, id) {
    if (id) return api().put(`/integration/webhooks/${id}`, body);
    return api().post('/integration/webhooks', body);
}

export async function deleteWebhook(id, schoolId) {
    return api().delete(`/integration/webhooks/${id}`, { params: { schoolId } });
}

export async function testWebhook(id, schoolId) {
    return api().post(`/integration/webhooks/${id}/test`, null, { params: { schoolId } });
}

export async function webhookLogs(id, schoolId, page = 1) {
    return api().get(`/integration/webhooks/${id}/logs`, { params: { schoolId, page } });
}

export async function integrationEvents() {
    return api().get('/integration/events');
}

export async function exportReceiptsUrl(schoolId, from, to, format) {
    const base = getApiBaseUrl();
    const token = localStorage.getItem('token');
    const q = new URLSearchParams({ schoolId, from, to, format });
    return `${base}/integration/export/receipts?${q}&access_token=${token}`;
}

export function downloadExport(path, params) {
    return api().get(path, { params, responseType: 'blob' });
}

export async function listExportTemplates(schoolId) {
    return api().get('/export/templates', { params: { schoolId } });
}

export async function listExportJobs(schoolId) {
    return api().get('/export/jobs', { params: { schoolId } });
}

export async function saveExportJob(body, id) {
    if (id) return api().put(`/export/jobs/${id}`, body);
    return api().post('/export/jobs', body);
}

export async function runExportJob(id, schoolId) {
    return api().post(`/export/jobs/${id}/run-now`, null, { params: { schoolId } });
}

export async function testFtp(body) {
    return api().post('/export/jobs/test-ftp', body);
}

export async function listAllWebhookLogs(schoolId, params = {}) {
    return api().get('/integration/webhooks/logs', { params: { schoolId, ...params } });
}

export async function retryWebhookLog(logId, schoolId) {
    return api().post(`/integration/webhooks/logs/${logId}/retry`, null, { params: { schoolId } });
}

export async function reorderAdminReferences(items) {
    return adminApi().post('/admin/references/reorder', items);
}

export async function validateAdminSql(sql) {
    return adminApi().post('/admin/export/templates/validate-sql', { sql });
}

export async function createAdminExportTemplate(body) {
    return adminApi().post('/admin/export/templates', body);
}

export async function listAdminExportTemplates() {
    return adminApi().get('/export/templates');
}
